<template>
    <v-dialog v-model="dialog" width="780px" max-width="80%">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text class="px-0">
                <v-chip v-model="request.area" v-bind="chipProps" color="primary" class="mr-2"> {{ request.area.parent.name }} /{{ request.area.name }} </v-chip>
                외 {{ areas.length - 1 }} 개
            </v-btn>
        </template>
        <v-card>
            <v-col>
                <v-chip-group :value="request._area" column color="primary">
                    <v-chip v-for="area in areas" :key="area._id" v-bind="chipProps" :value="area._id" disabled style="opacity:1">{{ area.parent.name }} /{{ area.name }}</v-chip>
                </v-chip-group>
            </v-col>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ["areas", "request"],
    data() {
        return {
            dialog: false,
            chipProps: {
                filter: true,
                outlined: true,
            },
        };
    },
};
</script>

<style></style>
